import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive/src';
import PageTemplate from 'components/templates/pageTemplate';
import { PageLoader } from 'components/molecules/pageLoader';
import WorkingAtTESection from 'components/templates/workingAtTE';
import CareerDetailsBanner from 'components/organisms/careerDetailsBanner';
import FooterSection from 'components/templates/footer';
import { HomeActions } from 'modules/home/actions';
import { HomeSelector } from 'modules/home/selector';
import { TestimonialActions } from 'modules/testimonials/action';
import { TestimonialSelector } from 'modules/testimonials/selector';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
import { CmsPagesActions } from 'modules/cmsPages/actions';
import { RouteNames } from 'router';
import Testimonial from 'components/templates/testimonial/careerTestimonial';
import { get, isEmpty } from 'lodash';
import { ShareModal } from 'components/templates/shareModal';
import CultureLeadershipSection from 'components/templates/cultureLeadershipSection';
import AboutRoleSection from 'components/templates/careersAboutRole';
import { CareerActions } from 'modules/careers/actions';
import { CareerSelector } from 'modules/careers/selector';
import RelatedJobRoles from 'components/templates/relatedJobRoles';
import { CmsDetailsSelector } from 'modules/cmsDetails/selector';
import { CmsDetailsActions } from 'modules/cmsDetails/actions';
import { ApplyForJobButton } from 'components/organisms/applyForJobButton';
import { ShareButton } from 'components/atoms/shareButton';
import { FooterActions } from 'modules/footerLink/actions';
import { FooterSelector } from 'modules/footerLink/selector';

const CareerDetails = props => {
  const {
    isLoading,
    getVerticals,
    verticals,
    verticalId,
    getSiteSettings,
    siteSettings,
    getPageData,
    getTestimonialData,
    testimonialData,
    footerLink,
    getFooterLinkData,
    workingAtTESectionData,
    ourDifferenceData,
    getJobDetails,
    specificJobData,
    relatedRoles,
    getJobPosts,
    cmsDetailsData,
    getCmsDetailsData,
    getBannerData,
  } = props;

  const isMobile = useMediaQuery({ query: '(max-device-width: 560px)' });
  const type = 'Career';
  const url_slug = props.match.params.careerSlug;
  let [theme, setTheme] = useState(isMobile ? 'dark-theme' : 'light-theme');
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const roleName = get(specificJobData, 'name', '');
  const jobEmail = get(specificJobData, 'email', '');

  useEffect(() => {
    getVerticals();
    getSiteSettings();
    getPageData();
    getTestimonialData(verticalId, type);
    getJobDetails(url_slug);
    getJobPosts();
    getCmsDetailsData();
    getFooterLinkData();
    getBannerData();
  }, []);

  if (isLoading) {
    return <PageLoader isMobile={isMobile} />;
  }

  if (
    !workingAtTESectionData ||
    !testimonialData ||
    !ourDifferenceData ||
    !specificJobData ||
    !relatedRoles ||
    !siteSettings ||
    !getCmsDetailsData ||
    !footerLink
  ) {
    return null;
  }

  const onShareClick = () => {
    setIsShareModalOpen(true);
  };

  const closeShareModal = () => {
    setIsShareModalOpen(false);
  };

  const componentList = [
    ...(!isEmpty(specificJobData)
      ? [
          {
            component: CareerDetailsBanner,
            data: { specificJobData },
            theme: isMobile ? 'dark-theme' : 'light-theme',
            sectionId: 'banner',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Careers',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(specificJobData)
      ? [
          {
            component: AboutRoleSection,
            data: { specificJobData, roleName },
            theme: 'light-theme',
            sectionId: 'about-the-role',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Careers',
                breadcrumbLink: RouteNames.careers,
              },
              {
                breadcrumbName: `${roleName}`,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(workingAtTESectionData)
      ? [
          {
            component: WorkingAtTESection,
            data: {
              workingAtTESectionData,
              roleName,
            },
            theme: 'light-theme',
            sectionId: 'working-at-total-env',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Careers',
                breadcrumbLink: RouteNames.careers,
              },
              {
                breadcrumbName: 'Working at Total Environment',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(testimonialData)
      ? [
          {
            component: Testimonial,
            theme: 'dark-theme',
            sectionId: 'testimonials',
            data: {
              testimonialData,
              show_mobile_apply_button: true,
              roleName,
              type: 'testimonial',
            },
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Careers',
                breadcrumbLink: RouteNames.careers,
              },
              {
                breadcrumbName: 'Testimonials',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(ourDifferenceData)
      ? [
          {
            component: CultureLeadershipSection,
            data: {
              ourDifferenceData,
              cmsDetailsData,
            },
            sectionId: 'culture-and-leadership',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Careers',
                breadcrumbLink: RouteNames.careers,
              },
              {
                breadcrumbName: 'Culture & Leadership Principles',
                breadcrumbLink: '#',
              },
            ],
            theme: 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(relatedRoles)
      ? [
          {
            component: RelatedJobRoles,
            sectionId: 'related-roles',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Careers',
                breadcrumbLink: RouteNames.careers,
              },
              {
                breadcrumbName: 'Related Roles',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
            data: { data: relatedRoles },
          },
        ]
      : []),
    {
      component: FooterSection,
      theme: 'dark-theme',
      sectionId: 'te-links',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Careers',
          breadcrumbLink: RouteNames.careers,
        },
        {
          breadcrumbName: 'Links',
          breadcrumbLink: '#',
        },
      ],
      data: { siteSettings, footerLink },
    },
  ];

  return (
    <div>
      <PageTemplate
        theme={theme}
        componentList={componentList}
        updateTheme={e => setTheme(e)}
        verticals={verticals}
        siteSettings={siteSettings}
        roleName={roleName}
        showGetInTouch={false}
        showApplyNow={true}
        headerButtons={
          <>
            <ApplyForJobButton
              mode={'light'}
              className={'apply-job-button'}
              roleName={roleName}
              jobEmail={jobEmail}
            />
            <ShareButton
              shareButtonClassName={'share'}
              onClick={() => setIsShareModalOpen(true)}
              mode={'dark'}
            />
          </>
        }
      />
      <ShareModal isOpen={isShareModalOpen} onClosePress={closeShareModal} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    isLoading:
      HomeSelector.isLoading(state) ||
      FooterSelector.isLoading(state) ||
      CareerSelector.getJobPostsLoading(state) ||
      CmsPagesSelector.isCmsPageLoading(state) ||
      TestimonialSelector.getTestimonialLoading(state) ||
      CmsDetailsSelector.getCmsDetailsDataLoading(state),
    verticals: HomeSelector.getVerticals(state),
    siteSettings: HomeSelector.getSiteSettings(state),
    footerLink: FooterSelector.getFooterData(state),
    workingAtTESectionData: CmsPagesSelector.getCmsPages(
      state,
      'Working at Total Environment',
      true
    ),
    testimonialData: TestimonialSelector.getTestimonialData(state),
    ourDifferenceData: CmsPagesSelector.getOurDifferenceSection(
      state,
      'culture-leadership',
      'Culture & Leadership Principles'
    ),
    specificJobData: CareerSelector.getSpecificJobPosts(state),
    relatedRoles: CareerSelector.getRelatedRoles(state),
    cmsDetailsData: CmsDetailsSelector.getCmsDetailsData(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { getVerticals, getSiteSettings, getBannerData } = HomeActions;
  const { getPageData } = CmsPagesActions;
  const { getTestimonialData } = TestimonialActions;
  const { getJobDetails, getJobPosts } = CareerActions;
  const { getCmsDetailsData } = CmsDetailsActions;
  const { getFooterLinkData } = FooterActions;
  return bindActionCreators(
    {
      getVerticals,
      getSiteSettings,
      getPageData,
      getTestimonialData,
      getJobDetails,
      getJobPosts,
      getCmsDetailsData,
      getBannerData,
      getFooterLinkData,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(CareerDetails);
